import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import tools from "../ToolCard/data/tools";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Sidebar from "../../components/Sidebar/Sidebar";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { useTheme } from '../../context/ThemeContext';

// Import all tool components
import FancyTextGenerator from '../../Pages/FancyTextGeneratorToolPages/FancyTextGenerator';
import SocialMediaMockupGenerator from '../../Pages/SocialMediaMockupGeneratorToolPages/SocialMediaMockupGenerator';
import CalendarShareLink from '../../Pages/CalendarShareLinkToolPages/CalendarShareLink';
import OnlineVoiceRecord from '../../Pages/OnlineVoiceRecordToolPages/OnlineVoiceRecord';
import MortageCalculator from '../../Pages/MortageCalculator/MortageCalculator';
import PasswordGenerator from '../../Pages/RandomPasswordGenerator/randomPasswordGenerator';
import GoogleAdsCalculator from '../../Pages/GoogleAdsCalculatorToolPage/GoogleAdsCalculator';
import MultiUrlOpener from '../../Pages/MultiUrlOpenerToolPages/MultiUrlOpener';
import EmailValidation from '../../Pages/EmailValidationToolPage/EmailValidation';
import InvoiceGenerator from '../../Pages/InvoiceGeneratorToolPage/InvoiceGenerator';
import ColorPicker from '../../Pages/ColorPicker/ColorPicker';
import ImageCompressor from '../../Pages/compressImage/compressImage';
import LoanCalculator from '../../Pages/LoanAmotizationCalculator/loanAmotizationCalculator';
import AdvancedLoanCalculator from '../../Pages/LoanCalculator/loanCalculator';
import NumToWords from '../../Pages/numToWords/NumToWords';
import PercentageCalculator from '../../Pages/PercentageCalculator/percentageCalculator';
import QRCodeGenerator from '../../Pages/QRCodeGenerator/QRCodeGenerator';
import RemoveDuplicate from '../../Pages/RemoveDuplicate/RemoveDuplicate';
import PDFSplitterPro from '../../Pages/SplitPdf/SplitPdf';
import TextToSpeech from '../../Pages/TextToSpeech/textToSpeech';
import PngToJpg from '../../Pages/PngToJpg/PngToJpg';
import JpgToPng from '../../Pages/JpgToPng/JpgToPng';
import HeicToJpgConverter from '../../Pages/HEICtoJPG/HeicToJpgConverter';
import WebPToJpgConverter from '../../Pages/WebPToJpgConverter/WebPToJpgConverter';
import WebpToJpegConvert from '../../Pages/WebpToJpegConverter/WebpToJpegConvert';
import WordToJpgConverter from '../../Pages/WordToJpgConverter/WordToJpgConverter';
import JpegToWordConverter from '../../Pages/JpegToWordConverter/JpegToWordConverter';
import PdfToWordConverter from '../../Pages/PdfToWordConverter/PdfToWordConverter';
import PptToPdfConverter from '../../Pages/PptToPdfConverter/PptToPdfConverter';
import ExcelToPdfConverter from '../../Pages/ExcelToPdfConverter/ExcelToPdfConverter';
import PdfToJpgConverter from '../../Pages/PdfToJpgConverter/PdfToJpgConverter';
import JpgToPdfConverter from '../../Pages/JpgToPdfConverter/JpgToPdfConverter';
import PdfMerger from '../../Pages/PdfMerger/PdfMerger';
import WordToJpegConverter from '../../Pages/WordToJpegConverter/WordToJpegConverter';
import Base64Decode from '../../Pages/ConvertingToolsPages/Base64Decode';
import Base64Encode from '../../Pages/ConvertingToolsPages/Base64Encode';
import BinaryToDecimal from '../../Pages/ConvertingToolsPages/BinaryToDecimel';
import BinaryToHex from '../../Pages/ConvertingToolsPages/BinaryToHex';
import BinaryToOctal from '../../Pages/ConvertingToolsPages/BinaryToOctal';
import BinaryToString from '../../Pages/ConvertingToolsPages/BinaryToString';
import DataSizeConverter from '../../Pages/ConvertingToolsPages/DataSizeConverter';
import DecimalToBinary from '../../Pages/ConvertingToolsPages/DecimalToBinary';
import DecimalToHex from '../../Pages/ConvertingToolsPages/DecimalToHex';
import DecimalToOctal from '../../Pages/ConvertingToolsPages/DecimalToOctal';
import HexToBinary from '../../Pages/ConvertingToolsPages/HexToBinary';
import HexToDecimal from '../../Pages/ConvertingToolsPages/HexToDecimal';
import HexToOctal from '../../Pages/ConvertingToolsPages/HexToOctal';
import MD5Hash from '../../Pages/ConvertingToolsPages/MD5Hash';
import OctalToBinary from '../../Pages/ConvertingToolsPages/OctalToBinary';
import OctalToDecimal from '../../Pages/ConvertingToolsPages/OctalToDecimal';
import OctalToHex from '../../Pages/ConvertingToolsPages/OctalToHex';
import RGBToHex from '../../Pages/ConvertingToolsPages/RGBtoHEX';
import SHA1Hash from '../../Pages/ConvertingToolsPages/SHA1Hash';
import SHA256Hash from '../../Pages/ConvertingToolsPages/SHA256Hash';
import SHA512Hash from '../../Pages/ConvertingToolsPages/SHA512Hash';
import StringToBinary from '../../Pages/ConvertingToolsPages/StringToBinary';
import WordCount from '../../Pages/ConvertingToolsPages/WordCounter';
import JpegToBmpConverter from '../../Pages/JpegToBmpConverter/JpegToBmpConverter';
import TermsFeedPage from '../../Pages/PoliciesTermsToolPages/TermsFeedPage';
import Permission from '../../store/permissions';
import TextToHandwriting from '../../Pages/TextToHandwriting/TextToHandwriting';
import CaseConverter from '../../Pages/CaseConverter/CaseConverter';
import LetterCounter from '../../Pages/LetterCounter/LetterCounter';
import LoremIpsumGenerator from '../../Pages/LoremIpsumGenerator/LoremIpsumGenerator';
import BionicReadingConverter from '../../Pages/BionicReadingConverter/BionicReadingConverter';
import WhitespaceRemover from '../../Pages/WhitespaceRemover/WhitespaceRemover';
import FontPairFinder from '../../Pages/FontPairFinder/FontPairFinder';
import GitignoreGenerator from '../../Pages/GitignoreGenerator/GitignoreGenerator';
import SortingVisualizer from '../../Pages/SortingVisualizer/SortingVisualizer';

const toolComponents = {
  "fancy-text-generator": FancyTextGenerator,
  "social-media-mockup-generator": SocialMediaMockupGenerator,
  "policies-terms": TermsFeedPage,
  "google-ads-calculator": GoogleAdsCalculator,
  "voice-recorder-online": OnlineVoiceRecord,
  "calendar-share": CalendarShareLink,
  "multi-url-opener": MultiUrlOpener,
  "invoice-generator": InvoiceGenerator,
  "compress-image": ImageCompressor,
  "color-picker": ColorPicker,
  "mortage-calculator": MortageCalculator,
  "loan-calculator": AdvancedLoanCalculator,
  "loan-amortization-calculator": LoanCalculator,
  "num-to-words": NumToWords,
  "percentage-calculator": PercentageCalculator,
  "qr-code-generator": QRCodeGenerator,
  "random-password-generator": PasswordGenerator,
  "remove-duplicate": RemoveDuplicate,
  "split-pdf": PDFSplitterPro,
  "text-to-speach": TextToSpeech,
  "text-to-handwriting": TextToHandwriting,
  "jpg-to-png": JpgToPng,
  "png-to-jpg": PngToJpg,
  "heic-to-jpg": HeicToJpgConverter,
  "webp-to-jpg-converter": WebPToJpgConverter,
  "word-to-jpg-converter": WordToJpgConverter,
  "jpeg-to-word-converter": JpegToWordConverter,
  "pdf-to-word-converter": PdfToWordConverter,
  "ppt-to-pdf-converter": PptToPdfConverter,
  "excel-to-pdf-converter": ExcelToPdfConverter,
  "pdf-to-jpg-converter": PdfToJpgConverter,
  "jpg-to-pdf-converter": JpgToPdfConverter,
  "pdf-merger": PdfMerger,
  "word-to-jpeg-converter": WordToJpegConverter,
  "email-validator": EmailValidation,
  "binary-to-decimal": BinaryToDecimal,
  "binary-to-hex": BinaryToHex,
  "binary-to-octal": BinaryToOctal,
  "binary-to-string": BinaryToString,
  "data-size-converter": DataSizeConverter,
  "decimal-to-binary": DecimalToBinary,
  "decimal-to-hex": DecimalToHex,
  "decimal-to-octal": DecimalToOctal,
  "hex-to-binary": HexToBinary,
  "hex-to-decimal": HexToDecimal,
  "hex-to-octal": HexToOctal,
  "md5-hash": MD5Hash,
  "octal-to-binary": OctalToBinary,
  "octal-to-decimal": OctalToDecimal,
  "octal-to-hex": OctalToHex,
  "rgb-to-hex": RGBToHex,
  "string-to-binary": StringToBinary,
  "sha1-hash": SHA1Hash,
  "sha256-hash": SHA256Hash,
  "sha512-hash": SHA512Hash,
  "word-count": WordCount,
  "webp-to-jpeg-convert": WebpToJpegConvert,
  "base-64-decode": Base64Decode,
  "base-64-encode": Base64Encode,
  "jpeg-to-bmp-converter": JpegToBmpConverter,
  "case-converter": CaseConverter,
  "lorem-ipsum-generator": LoremIpsumGenerator,
  "letter-counter": LetterCounter,
  "bionic-reading-converter": BionicReadingConverter,
  "whitespace-remover": WhitespaceRemover,
  "font-pair-finder": FontPairFinder,
  "gitignore-generator": GitignoreGenerator,
  "sorting-visualizer": SortingVisualizer,


};

const ToolLayout = () => {
  useTheme();
  const { id, '*': path } = useParams();
  const [darkMode, setDarkMode] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [mobileSearchVisible, setMobileSearchVisible] = useState(false);
  const [toast, setToast] = useState({ visible: false, message: "" });
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem('favorites');
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  // Move all useEffect hooks to the top level
  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    const prefersDark =
      localStorage.getItem("darkMode") === "true" ||
      (!localStorage.getItem("darkMode") &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);

    if (prefersDark) {
      setDarkMode(true);
      document.documentElement.classList.add("dark");
    }

    // Add scrollbar styles
    const style = document.createElement('style');
    style.textContent = `
      /* Custom Scrollbar */
      ::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
    
      ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []); // Empty dependency array since this should only run once

  const toggleFavorite = (toolPath) => {
    setFavorites(prev => {
      const newFavorites = prev.includes(toolPath)
        ? prev.filter(path => path !== toolPath)
        : [...prev, toolPath];
      localStorage.setItem('favorites', JSON.stringify(newFavorites));
      return newFavorites;
    });
  };

  const showToast = (message) => {
    setToast({ visible: true, message });
    setTimeout(() => setToast({ visible: false, message: "" }), 3000);
  };

  const renderNestedContent = () => {
    if (!path) return null;
    
    const pathParts = path.split('/');
    const route = pathParts[0];
    const param = pathParts[1];
    
    if (id === 'policies-terms') {
      if (route === 'form' && param) {
        const FormPage = require('../../Pages/PoliciesTermsToolPages/FormPage').default;
        return <FormPage />;
      } else if (route === 'download' && param) {
        const PoliciesPage = require('../../Pages/PoliciesTermsToolPages/PoliciesPage').default;
        return <PoliciesPage />;
      }
    }
    
    return null;
  };
  const nestedContent = renderNestedContent();
  if (nestedContent) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header
          darkMode={darkMode}
          toggleDarkMode={() => setDarkMode(!darkMode)}
          searchActive={searchActive}
          setSearchActive={setSearchActive}
          mobileSearchVisible={mobileSearchVisible}
          setMobileSearchVisible={setMobileSearchVisible}
        />
        <main className="flex-grow">
          {nestedContent}
        </main>
        <Footer />
      </div>
    );
  }

  // Find the tool by path
  const tool = tools.find((t) => t.path === id);

  if (!tool) {
    return (
      <div className="bg-gray-100 font-sans dark:bg-gray-900 transition-colors duration-200">
        <div className="min-h-screen flex flex-col">
          <Header
            darkMode={darkMode}
            toggleDarkMode={() => setDarkMode(!darkMode)}
            searchActive={searchActive}
            setSearchActive={setSearchActive}
            mobileSearchVisible={mobileSearchVisible}
            setMobileSearchVisible={setMobileSearchVisible}
          />
          <main className="flex-grow container mx-auto px-4 py-8">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 text-center">
              <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Tool not found</h1>
              <p className="text-gray-600 dark:text-gray-300 mt-2">The requested tool could not be found.</p>
            </div>
          </main>
          <Footer />
        </div>
      </div>
    );
  }

  const ToolComponent = toolComponents[tool.path];
  
  if (!ToolComponent) {
    return (
      <div className="bg-gray-100 font-sans dark:bg-gray-900 transition-colors duration-200">
        <div className="min-h-screen flex flex-col">
          <Header
            darkMode={darkMode}
            toggleDarkMode={() => setDarkMode(!darkMode)}
            searchActive={searchActive}
            setSearchActive={setSearchActive}
            mobileSearchVisible={mobileSearchVisible}
            setMobileSearchVisible={setMobileSearchVisible}
          />
          <main className="flex-grow container mx-auto px-4 py-8">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 text-center">
              <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Tool component not found</h1>
              <p className="text-gray-600 dark:text-gray-300 mt-2">The tool component could not be loaded.</p>
            </div>
          </main>
          <Footer />
        </div>
      </div>
    );
  }
  return (
    <div className="bg-gray-100 font-sans dark:bg-gray-900 transition-colors duration-200">
      <div className="min-h-screen flex flex-col">
        <Header
          darkMode={darkMode}
          toggleDarkMode={() => setDarkMode(!darkMode)}
          searchActive={searchActive}
          setSearchActive={setSearchActive}
          mobileSearchVisible={mobileSearchVisible}
          setMobileSearchVisible={setMobileSearchVisible}
        />

        <main className="flex-grow container mx-auto px-0 md:px-2 py-8">
          <div className="tool-layout grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-6">
            <div className="tool-content ">
              <HeaderSection
                toolId={tool.path}
                isFavorite={favorites.includes(tool.path)}
                onFavoriteToggle={toggleFavorite}
                title={tool.title}
                description={tool.description}
                onShareClick={() => showToast("Share link copied to clipboard")}
                onReportClick={() => showToast("Report submitted")}
              />
              
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition mb-6 ">
                {tool.path === "policies-terms" || tool.path === "social-media-mockup-generator" || tool.path === "invoice-generator" ? (
                  <Permission>
                    <ToolComponent />
                  </Permission>
                ) : (
                  <ToolComponent  />
                )}
              </div>

              <BottomSection toolId={tool.path} />
            </div>
            <Sidebar />
          </div>
        </main>
        
        {/* Toast notification */}
        {toast.visible && (
          <div className="fixed bottom-4 right-4 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg animate-fade-in">
            {toast.message}
          </div>
        )}
        
        <Footer />
      </div>
    </div>
  );
};

export default ToolLayout;